import { format } from "date-fns"
import { sl } from "date-fns/locale"
import { observer } from "mobx-react-lite"
import { IEventCollectionItem } from "../../interfaces"
import { Image, Text } from "../."

interface IBadgeCard {
	event: IEventCollectionItem
}
export const BadgeCard = observer(({ event }: IBadgeCard) => {
	return (
		<div className="mt-[10px] flex flex-row items-center">
			<Image url={event.heroImage} width={50} height={50} />

			<div className="ml-[10px] flex flex-col">
				<div className="mb-[4px] text-xs font-light">
					<Text>
						{format(new Date(event.start), "d. MMMM yyyy", {
							locale: sl,
						})}
					</Text>
				</div>
				<div>
					<Text style="font-bold text-base text-sm">{event.name}</Text>
				</div>
			</div>
		</div>
	)
})
